import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { DialogService } from '../services/dialog.service';
import { AlertService } from '../services/alert.service';
import { AppTranslationService } from "../services/app-translation.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private alertService: AlertService,
    private dialogService: DialogService,
    private translationService: AppTranslationService,
    private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      let errmess: string = "";
      if (err.status === 401)
        errmess = this.translationService.getTranslation('notifications.AutoLogout'); // auto logout if 401 response returned from api
      else if (err.status == 400) {
        errmess = this.translationService.getTranslation('notifications.ServerError');
      }
      else if (err.status == 404)
        errmess = this.translationService.getTranslation('notifications.NotFound');
      else if (err.status == 417)
        errmess = this.translationService.getTranslation('notifications.NoUserOrPwd');
      else if (err.status == 418)
        errmess = this.translationService.getTranslation('notifications.NoUserData');
      else if (err.status == 419)
        errmess = this.translationService.getTranslation('notifications.UserRightsExpired');
      else if (err.status == 420)
        errmess = this.translationService.getTranslation('notifications.WrongUser');
      else if (err.status == 421)
        errmess = this.translationService.getTranslation('notifications.NoLicense');
      else if (err.status == 422)
        errmess = this.translationService.getTranslation('notifications.LicenseExpired');
      else if (err.status == 423)
        errmess = this.translationService.getTranslation('notifications.FeatureNotLicensed');
      else if (err.status == 424)
        errmess = this.translationService.getTranslation('notifications.NoUserRights');
      else if (err.status == 425)
        errmess = this.translationService.getTranslation('notifications.SystemNotDefined');
      else if (err.status == 426)
        errmess = this.translationService.getTranslation('notifications.MaxPersonsExceeded');
      else if (err.status == 427)
        errmess = this.translationService.getTranslation('notifications.NoDbConnection');
      else if (err.status == 428)
        errmess = this.translationService.getTranslation('notifications.NoWsUse');
      else if (err.status == 429)
        errmess = this.translationService.getTranslation('notifications.MaxGusersExceeded');
      else if (err.status == 430)
        errmess = this.translationService.getTranslation('notifications.InsertRecordFailed') + " " + err.error;
      else if (err.status == 431)
        errmess = this.translationService.getTranslation('notifications.UpdateRecordFailed') + " " + err.error;
      else if (err.status == 432)
        errmess = this.translationService.getTranslation('notifications.DeleteRecordFailed') + " " + err.error;
      //else if (err.status == 501)
      //  errmess = this.translationService.getTranslation('notifications.CalendarSequenceError');
      //else if (err.status == 502)
      //  errmess = this.translationService.getTranslation('notifications.JustOneNullEnddate');
      //else if (err.status == 503)
      //  errmess = this.translationService.getTranslation('notifications.DateOverlapping');
      else
        errmess = this.translationService.getTranslation('notifications.UndefinedError') + " " + err.error;
      if (err.status > 500) {
        this.alertService.showDialog(errmess);
      }
      else if (err.status > 429) {
        this.alertService.errorMessage(errmess);
      }
      else {
        if (this.authService.isLoggedIn)
          this.authService.autoLogout();
        this.alertService.error(errmess, false);
      }
      return throwError(errmess);

    }))
  }
}
